import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ImageStore {

}

export enum ImageStoreKeys {

}
